import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateMyInformationAction } from '../../../redux/actions/meActions';
import ChangeMyInfoForm from './ChangeMyInfoForm';

const ChangeMyInfo = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.auth?.userData);

  const handleChangeMyInfo = async (data) => {
    setLoading(true);
    dispatch(updateMyInformationAction(data));
    setLoading(false);
  };

  return <ChangeMyInfoForm userData={userData} handleChangeMyInfo={handleChangeMyInfo} loading={loading} />;
};

export default ChangeMyInfo;
